import React, { useState } from 'react';
import { Card, CardActionArea, CardMedia, CardContent, 
    Typography, CardActions, Button, Dialog, DialogContent, 
    IconButton, Grid, Hidden } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from '../project-card/project-card.module.scss';
import CodeIcon from '@material-ui/icons/Code';
import VisibilityIcon from '@material-ui/icons/Visibility';

function ProjectCard(props) {
    const [open, setOpen] = useState(false);

    const handleDialogOpen = (project) => {
        setOpen(true);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullScreen 
                onClose={handleDialogClose} 
                aria-labelledby="Project Images and Details" 
                className={styles.projectDialog}>
                <React.Fragment>
                    <div className={styles.dialogContentWrapper}>
                        <DialogContent className={styles.content}>
                            <Grid container className={styles.stickyBack}>
                                <Grid item xs={12} className={styles.backWrapper}>
                                    <Button 
                                        className={styles.closeDialogIcon} 
                                        onClick={handleDialogClose}
                                        endIcon={<CloseIcon />}
                                    >
                                        Back
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container className={styles.projectIntro}>
                                <Grid item xs={12} md={6}>
                                    <h1>{props.project.title}</h1>
                                    <h3>{props.project.technology}</h3>
                                    <p>{props.project.summary}</p>
                                </Grid>
                            </Grid>
                            { props.project.projectImages.map(slide => {
                                return (
                                    <React.Fragment key={slide.url}>
                                            <Grid container className={styles.info} spacing={2}>
                                                <Grid item xs={12} lg={7} className={styles.caption}>
                                                    <p>{slide.caption}</p>
                                                </Grid>
                                                <Grid item xs={12} lg={5}>
                                                    <img
                                                        src={slide.url}
                                                        className={styles.projectImg}
                                                        alt={slide.caption}
                                                    />
                                                </Grid>
                                            </Grid>
                                    </React.Fragment>
                                )
                            })  
                            }
                             <Grid container className={styles.videoContainer}>
                                 <Grid item xs={12}>
                                    <h2>Video Demonstration</h2>
                                 </Grid>
                                <Grid item xs={12} className={styles.videoGridItem}>
                                    <iframe width="800" height="400" title="Product Tour" src={props.project.video} className={styles.video} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </div>
                </React.Fragment> 
            </Dialog>
            <Card className={styles.card}>
                <CardActionArea>
                    <CardMedia
                        image={props.project.image}
                        className={styles.cardImg}
                        onClick={handleDialogOpen}
                    />
                    <CardContent onClick={handleDialogOpen}>
                        <Typography gutterBottom variant="h5" component="h2" className={styles.projectTitle}>
                            {props.project.title}
                        </Typography>
                        <Typography gutterBottom variant="subtitle1" component="h2" className={styles.projectTitle}>
                            {props.project.technology}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p" className={styles.blurb}>
                            {props.project.blurb}
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Hidden lgUp>
                        <IconButton aria-label="view project" onClick={handleDialogOpen}>
                            <VisibilityIcon />
                        </IconButton>
                        <IconButton aria-label="view source code on Github" href={props.project.sourceCode} target="_blank" rel="noreferrer noopener">
                            <CodeIcon />
                        </IconButton>
                    </Hidden>
                    <Hidden mdDown>
                        <Button size="small" className={styles.viewProject} onClick={handleDialogOpen}>
                            See More
                        </Button>
                        {props.project.sourceCode &&
                            <Button size="small" className={styles.viewProject} href={props.project.sourceCode} target="_blank" rel="noreferrer noopener">
                                Source Code
                            </Button>
                        }
                    </Hidden>
                </CardActions>
            </Card>
        </React.Fragment>
    );
}

export default ProjectCard;